import React from 'react';
import Skeleton from 'react-loading-skeleton';
import parse from 'html-react-parser';
import { FooterProps, NavmenuProps, Social } from "../typescript/layout";

export default function Footer({ footer }: { footer: FooterProps, navMenu: NavmenuProps }) {
  return (
    <footer>
      <div className='max-width footer-div-main'>
        {footer.copyright ? (
          <>
            <div className='footer-text'>
              <h1 className="Logos">Composable Hero</h1>
            </div>
            <div className='copyright'  {...footer.$?.copyright as {}}>
              {parse(footer.copyright)}
            </div></>
        ) : (
          <div className='copyright'>
            <Skeleton width={200} />
          </div>
        )}
        <div className='max-width footer-div'>
          {Object.keys(footer).length ? (
            footer.social.social_share?.map((social: Social, index) => (
              <a
                href={social.link.href}
                title={social.link.title}
                key={social.link.title} >
                <div key={`footer-logo-${index}`}
                  className='powered-by'
                  style={{
                    backgroundImage: `url(${social.icon.url})`,
                  }}
                >
                </div>
              </a>
            ))
          ) : (
            <div className='footer-text'>
              <Skeleton width={100} />
            </div>
          )}
        </div>
        <div className='mt-3' >
          <p className='text-white'>Copyright © 2023 Contentstack Inc. All rights reserved. </p>
        </div>
      </div>
    </footer>
  );
}
